import request from '@/utils/request'

export function upload(obj) {
  return request({
    url: '/admin/sys-file/upload',
    method: 'post',
    data: obj
  })
}
